import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEditorStatus,
  getEditorStatus,
} from '@domains/orchestrator-pricing-committee/store/slices/domainOrchestratorPricingCommittee.slice';

const statuses = ['COMPLETED', 'IN_PROGRESS', 'REJECTED'] as const;

export const EditorStatusSelect = () => {
  const dispatch = useDispatch();
  const editorStatus = useSelector(getEditorStatus);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    dispatch(setEditorStatus(e.target.value as (typeof statuses)[number]));
  };

  return (
    <Form.Select
      data-testid="editor-status-select"
      style={{ width: '200px' }}
      value={editorStatus}
      onChange={handleChange}
    >
      {statuses.map(status => (
        <option key={status} value={status}>
          {status}
        </option>
      ))}
    </Form.Select>
  );
};
